import type { ReactNode } from 'react';

import { BottomBar, cn } from '@yummy/ui-rnr';

/**
 * The footer bar this app's screens use.
 *
 * The kit's `BottomBar` reserves extra room along the bottom for a home
 * indicator, which is right for the merchant tablet. Here the footer *is* the
 * bottom of the screen — nothing sits below the cart bar or the checkout bar —
 * so that reserve left both of them sitting high with dead space beneath.
 *
 * One place rather than a class on each footer, so the two bars cannot drift.
 *
 * @param props The footer's content, and any classes the screen needs to add.
 * @returns A footer bar trimmed to the bottom of the phone screen.
 */
export function FooterBar({ children, className }: { children: ReactNode; className?: string }) {
  return <BottomBar className={cn('pb-3', className)}>{children}</BottomBar>;
}
